import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { db } from '../firebase';
import { query, collection, where, getDocs, updateDoc } from 'firebase/firestore';

const AdminPanel = () => {
  const [searchEmail, setSearchEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleUpgrade = async () => {
    if (!searchEmail) return alert("Lütfen bir e-posta adresi girin.");
    
    const confirm = window.confirm(`DİKKAT: ${searchEmail} adresini 1 Yıllık Premium yapmak istiyor musunuz?`);
    if (!confirm) return;

    setIsLoading(true);
    try {
      // 1. Veritabanında e-postayı bul
      const q = query(collection(db, "users"), where("email", "==", searchEmail.trim()));
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        alert("❌ HATA: Bu e-posta adresiyle kayıtlı bir kullanıcı bulunamadı!");
        setIsLoading(false);
        return;
      }

      // 2. Kullanıcıyı bulduk, tarihi hesapla (Bugün + 365 gün)
      const userDoc = snapshot.docs[0];
      const now = new Date();
      const nextYear = new Date(now.setFullYear(now.getFullYear() + 1));

      // 3. Veritabanını güncelle
      await updateDoc(userDoc.ref, {
        isPremium: true,
        premiumEndDate: nextYear.toISOString()
      });

      alert(`✅ İŞLEM BAŞARILI!\n\n${searchEmail} artık 1 Yıllık Premium üye yapıldı.\nBitiş Tarihi: ${nextYear.toLocaleDateString('tr-TR')}`);
      setSearchEmail('');
    } catch (error) {
      console.error(error);
      alert("Bir hata oluştu: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 p-8 rounded-3xl text-white shadow-xl">
        <h2 className="text-3xl font-black flex items-center mb-2">
          <Star className="h-8 w-8 text-amber-400 mr-3" /> Süper Admin Kontrol Merkezi
        </h2>
        <p className="text-slate-400 text-sm">Bu sayfayı sadece sen görebilirsin. Buradan kullanıcılara tek tıkla Premium yetkisi tanımlayabilirsin.</p>
      </div>

      <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm">
        <h3 className="text-lg font-bold text-slate-800 mb-4">Yeni Premium Üye Tanımla</h3>
        <div className="flex gap-4">
          <input 
            type="email" 
            placeholder="Müşterinin Kayıtlı E-posta Adresi" 
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
            className="flex-1 px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-amber-500 outline-none"
          />
          <button 
            onClick={handleUpgrade}
            disabled={isLoading}
            className="px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl transition shadow-md flex items-center whitespace-nowrap"
          >
            {isLoading ? "İşleniyor..." : "1 Yıl Premium Yap"}
          </button>
        </div>
        <p className="text-xs text-slate-500 mt-4">
          * İşlemi onayladığınız an, kullanıcının bitiş tarihi bugünden itibaren tam 365 gün sonrasına otomatik ayarlanır.
        </p>
      </div>
    </div>
  );
};

export default AdminPanel;